// extracted by mini-css-extract-plugin
export default {"sideBar":"SideBarAccordion_sideBar__v3IdW","logo":"SideBarAccordion_logo__L7JUd"};